module.exports = __webpack_public_path__ + "static/media/newsImage6.97ab2a52.svg";